import { TRPCError } from '@trpc/server';
import { z } from 'zod';

export function isPreviewEnvironment(): boolean {
  return (
    process.env.VERCEL_ENV === 'preview' ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview' ||
    process.env.AURIUM_PREVIEW === 'true'
  );
}

const previewWriteResourcesSchema = z
  .object({
    storage: z.array(z.string().min(1)).optional(),
    'google-sheets': z.array(z.string().min(1)).optional(),
    browserbase: z.array(z.string().url()).optional(),
  })
  .strict();

type PreviewWriteTarget = {
  integration: keyof z.infer<typeof previewWriteResourcesSchema>;
  resourceId: string;
};

export function assertExternalWritesAllowed(target?: PreviewWriteTarget): void {
  if (!isPreviewEnvironment()) return;
  if (target?.resourceId && process.env.PREVIEW_EXTERNAL_WRITE_RESOURCES) {
    let resources: z.infer<typeof previewWriteResourcesSchema> | undefined;
    try {
      const parsed = previewWriteResourcesSchema.safeParse(
        JSON.parse(process.env.PREVIEW_EXTERNAL_WRITE_RESOURCES),
      );
      if (parsed.success) resources = parsed.data;
    } catch {
      // Invalid configuration grants no preview writes.
    }
    if (resources?.[target.integration]?.includes(target.resourceId)) return;
  }
  throw new TRPCError({
    code: 'FORBIDDEN',
    message: 'External writes and sends are disabled in previews',
  });
}
